import React from "react";
import { useAuthContext } from "@src/context/authContext";
import { useManagerContext } from "@src/context/managerContext";
import ManagerHooks from "@src/context/hooks/managerHooks";
import BehaviourDescriptionSection from "@src/pages/sharedSections/BehaviourDescriptionSection";

const DefinitionsTab = () => {
  const { profile, selectedBehaviour } = useManagerContext();
  const auth = useAuthContext();
  const target = {
    behaviourType: selectedBehaviour.behaviourAcronym || "",
  };
  const {
    data: { exclusions } = {},
    isPending: isPendingExclusions,
    error: errorExclusions,
  } = ManagerHooks.useGetBehaviourExclusions(auth.activeRole);

  return (
    <div className="px-20 pt-6">
      {isPendingExclusions ? (
        <div>Loading...</div>
      ) : errorExclusions ? (
        <div className="text-red-500">Error fetching exclusions data...</div>
      ) : (
        selectedBehaviour != null && (
          <BehaviourDescriptionSection
            target={target}
            exclusions={exclusions}
            behaviours={profile.behaviours}
            customer={profile.customer}
          />
        )
      )}
    </div>
  );
};

export default DefinitionsTab;
